export default __webpack_public_path__ + "static/huawei_gallery_badge_en-c9a65e7c74c63a801b6d66defcdcbed7.svg";